import { Surface } from '../../../../specification/Surface';
import { CaseProjection } from '../../CaseProjection';

export const getCaseAlreadyProjectedSurfaceForSale = (caseProjection: CaseProjection): Surface =>
  caseProjection.projectedSurfaceForSale;
